import { JsonPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  model,
  OnInit,
  signal,
} from '@angular/core';
import { NotificationService } from '@softapps/werkstatt/garage-core';
import { InputComponent, MultilineInputComponent, ResolvableModal } from '@softline/ui-core';

@Component({
  selector: 'soft-garage-sms-template',
  templateUrl: './garage-sms-template.component.html',
  styleUrls: ['./garage-sms-template.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [JsonPipe, MultilineInputComponent, InputComponent],
  providers: [],
})
export class GarageSmsTemplateComponent
  extends ResolvableModal<{ content: string; phone: string } | 'DISMISSED' | 'CANCEL'>
  implements OnInit
{
  readonly #notificationService = inject(NotificationService);
  id = input<number>();
  phone = model<string | null>(null);

  ngOnInit() {
    if (this.id()) this.#notificationService.loadNotificationTemplates(this.id()!);
  }

  notifications = computed(() => {
    const ids = this.id();
    if (!ids) {
      return null;
    }
    return this.#notificationService.notificationTemplates();
  });

  inputValue = signal<string | null>(null);
}
